export default class AnnouncementBar {
  constructor(section) {
    this.postMessage = section.postMessage;
    this.postMessage('announcement-load');
  }
}
